<template>
<div>
    <div class="container">
        <div class="notification">
            <center><img v-bind:src="this.logo" alt="School logo" width="250"></center>
            <center><h2 class="title is-1">{{ schoolInfo.name }}</h2></center>
            <!-- <center><h2 class="title is-5">{{ schoolInfo.address }}</h2></center><br/> -->
            <center><h2 class="title is-2">{{ this.formName }}</h2></center><br/>
            <center><qrcode-vue :value="qrCodeValue" :size="size" level="H"></qrcode-vue></center>
            <center><strong><a v-bind:href="this.qrCodeValue">{{ this.qrCodeValue }}</a></strong></center>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import QrcodeVue from 'qrcode.vue'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'DbFormDisplayLinkQR',
    components: {
        Loading,
        QrcodeVue,
    },
    data() {
        return {
            url: 'http://form.studentqr.com',
            qrCodeValue: '',
            size: 300,
            country: "",
            schoolNo: "",
            template: "",
            id: "",
            formName: "",
            schoolInfo: {},
            logo: "",
            input: {
                name: ""
            },
            result: "",
            errors: [],
            dataList: [{
                name: '',
                status: 1,
                createdAt: ""
            }],
            isLoading: false
        }
    },
    created() {
        console.log("imini query")
        console.log(this.$route.query)
        this.country = this.$route.query.country
        this.schoolNo = this.$route.query.schoolNo
        this.template = this.$route.query.template
        this.id = this.$route.query.id
        this.formName = this.$route.query.name

        this.qrCodeValue = this.url + "/" + this.template + "?id=" + this.country + this.id
        
        this.getSchoolInfo()
        // console.log(this.$router.currentRoute.name)
        // this.currentRouteName = this.$router.currentRoute.name
    },
    beforeMount() {
        this.$emit("authenticated", true)
    },
    methods: {  
        getSchoolInfo() {
            console.log("Entering getSchoolInfo with schoolId: " + localStorage.getItem('schoolID') + " and country: " + localStorage.getItem('country'))
            let self = this;
            this.isLoading = true;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('newToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/school/info', {
                    schoolId: localStorage.getItem('schoolID'),
                    country: localStorage.getItem('country')
                })
                .then(response => { 
                    console.log("84 response.data: ")
                    console.log(response.data)
                    this.schoolInfo = response.data.result
                    self.isLoading = false                    
                    console.log("98 this.schoolInfo: ")
                    console.log(this.schoolInfo)
                    
                    self.logo = process.env.MY_URL + "/public/logo?schoolID=" + localStorage.getItem('schoolID')  
                    console.log("self.logo")
                    console.log(self.logo)
                })
                .catch(e => {
                    self.isLoading = false
                    // this.errors.push(e)
                    console.log(e)
                })
        },

    }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
#app {
  font-family: 'Poppins' !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/Database/Form/DisplayLinkQR.vue